import React from 'react'
import { Select, MenuItem, InputLabel, FormControl } from '@mui/material'

export interface MembershipType {
  id: number
  code: string
  description: string
}

export const membershipTypeOptions = new Map<number, MembershipType>([
  [1, { id: 1, code: 'CIV', description: 'Civic Organization' }],
  [6, { id: 6, code: 'EDU', description: 'Educational Organization' }],
  [2, { id: 2, code: 'FRA', description: 'Fraternal Organization' }],
  [3, { id: 3, code: 'PRO', description: 'Professional Association' }],
  [4, { id: 4, code: 'SER', description: 'Service Organization' }],
  [5, { id: 5, code: 'OTH', description: 'Other' }]
])

export const MembershipTypeSelect: React.FC<{ value: MembershipType | null, updateMembershipType: (membershipType: MembershipType | null) => void, disabled: boolean }> = ({ value, updateMembershipType, disabled }) => {
  const handleChange = (value: string | number): void => {
    const selectedOption = membershipTypeOptions.get(value as number)
    updateMembershipType(selectedOption ?? null)
  }

  return (
    <FormControl fullWidth variant="outlined">
      <InputLabel id="membership-type-select-label">Membership Type</InputLabel>
      <Select
        labelId="membership-type-select-label"
        label="Membership Type"
        value={(value != null) ? value.id : ''}
        onChange={(event) => { handleChange(event.target.value) }}
        disabled={disabled}
        fullWidth
      >
        {Array.from(membershipTypeOptions.values()).map((membershipType) => (
          <MenuItem key={membershipType.id} value={membershipType.id}>
            {membershipType.description}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
